import { render, staticRenderFns } from "./ServiceReportSummary.vue?vue&type=template&id=54eea499&scoped=true"
import script from "./ServiceReportSummary.vue?vue&type=script&lang=js"
export * from "./ServiceReportSummary.vue?vue&type=script&lang=js"
import style0 from "./ServiceReportSummary.vue?vue&type=style&index=0&id=54eea499&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eea499",
  null
  
)

export default component.exports